export const cookiesRestrictionLevels = {
  allow_all: "allow_all",
  allow_essentials: "allow_essentials"
}
